import PartnersAdd from "./PartnersAdd";

export default PartnersAdd;
